'use strict';

const PayPalBaseModel = require('./payPalBase');
const helper = require('../../helpers/helper');
const api = require('../../helpers/api');

let that;

/**
 * Initiates a PayPalButtonExpress model (pvp, pdp, cart, mini-cart)
 * @param {string} payPalBtnSelector A container class where PayPal button will be initiated
 */
function PayPalExpressModel(payPalBtnSelector) {
    PayPalBaseModel.call(this, payPalBtnSelector);

    // This is used for handling shipping address and options
    this.shippingAddress = null;
    this.validationResponse = null;

    that = this;
}

PayPalExpressModel.prototype = Object.create(PayPalBaseModel.prototype);

/**
 * Process the generic (not Ba) Paypal button flow (cart, pdp, mini-cart)
 */
PayPalExpressModel.prototype.processGenericBtnFlow = function() {
    helper.returnFromCart.call(that, {})
        .catch((error) => {
            this.loader.hide();

            const isCartPage = this.payPalBtnSelector === '.js-paypal-button-on-cart-page';
            const isProductPage = this.payPalBtnSelector.includes('.js-paypal-button-on-product-page');

            if (helper.handleValidationAddressResult(error)) {
                if (isProductPage) {
                    helper.removeAllProductsFromCart();
                }
            } else if (isProductPage) {
                helper.removeAllProductsFromCart();

                PayPalExpressModel.prototype.onError.call(this, error);
            } else if (isCartPage) {
                this.onError(error);
            }
        });
};

/**
 * createOrder PayPal pop-up hook handler
 * @return {string} order id
 */
PayPalExpressModel.prototype.createOrder = function() {
    const emailAddress = that.payPalBtnContainerEl.dataset.customerEmail;
    const paymentSourceData = {
        paypal: {
            experience_context: {
                brand_name: that.merchantName
            }
        }
    };

    helper.assignEmailToPayPalPaymentSource(paymentSourceData, emailAddress);

    const isExpressCheckout = true;
    const orderIdData = api.getPaypalOrderId({ paymentSourceData, isExpressCheckout });

    helper.throwIfError(orderIdData);

    return orderIdData.id;
};

/**
 * onShippingAddressChange PayPal pop-up hook handler
 * @param {Object} data with shippingAddress
 * @param {Object} actions object with events
 */
PayPalExpressModel.prototype.onShippingAddressChange = async(data, actions) => {
    this.shippingAddress = {
        stateCode: data.shippingAddress.state,
        postalCode: data.shippingAddress.postalCode,
        city: data.shippingAddress.city,
        countryCode: data.shippingAddress.countryCode
    };

    this.validationResponse = await api.validatePayPalShippingAddress(this.shippingAddress);

    if (this.validationResponse.shippingAddressValidationResult.error) {
        await actions.reject(
            data.errors[this.validationResponse.shippingAddressValidationResult.errorCodes.shift()]
        );
    }

    const updateResponse = await api.updateShipment(Object.assign(this.validationResponse, this.shippingAddress));

    if (!updateResponse.success){
        await actions.reject(
            data.errors[this.validationResponse.shippingAddressValidationResult.errorCodes.shift()]
        );
    }
};

/**
 * onShippingOptionsChange PayPal pop-up hook handler
 * @param {Object} data with shippingAddress
 * @param {Object} actions object with events
 */
PayPalExpressModel.prototype.onShippingOptionsChange = async(data, actions) => {
    this.validationResponse = await api.validatePayPalShippingAddress(this.shippingAddress);

    if (this.validationResponse.shippingAddressValidationResult.error) {
        await actions.reject(
            data.errors[this.validationResponse.shippingAddressValidationResult.errorCodes.shift()]
        );
    }

    if (!that.sessionInstance.getItem(that.DEFAULT_PAYPAL_SHIPPING)) {
        that.sessionInstance.setItem(that.DEFAULT_PAYPAL_SHIPPING, JSON.stringify(Object.assign(this.validationResponse, this.shippingAddress)));
    }

    this.validationResponse.isBasketShippingMethodApplicable = false;
    this.validationResponse.defaultShippingMethodId = data.selectedShippingOption.id;

    const updateResponse = await api.updateShipment(Object.assign(this.validationResponse, this.shippingAddress));

    if (!updateResponse.success) {
        await actions.reject(
            data.errors[this.validationResponse.shippingAddressValidationResult.errorCodes.shift()]
        );
    }
};

/**
 * Hides loader on paypal widget closing without errors
 * Is used with adjacent instances (cart, pdp)
 */
PayPalExpressModel.prototype.onCancel = async() => {
    that.loader.hide();

    const shipping = helper.tryParseJSON(that.sessionInstance.getItem(that.DEFAULT_PAYPAL_SHIPPING));

    if (shipping) {
        await api.updateShipment(Object.assign(shipping, { isOnClose: true }));

        that.sessionInstance.removeItem(that.DEFAULT_PAYPAL_SHIPPING);
    }
};

/**
 * Initiates a Paypal button on express checkout page (Cart, mini-cart, pdp)
 * Is used with adjacent instances (cart, pdp, pvp)
 */
PayPalExpressModel.prototype.initPayPalButton = function() {
    this.loader.show();

    this.sdk = window.paypalSdkMiniCart || window.paypal;

    const shippingCallbacksObj = this.userIdToken ? {} : {
        onShippingAddressChange: this.onShippingAddressChange,
        onShippingOptionsChange: this.onShippingOptionsChange
    };

    const btnInitResult = this.sdk.Buttons(Object.assign(this.createBtnGeneralOption(), shippingCallbacksObj));

    if (btnInitResult.isEligible()) {
        btnInitResult.render(this.payPalBtnSelector);

        this.loader.hide();
    }

    const buttonMessageStyle = helper.getPaypalButtonMessageStyle(document.querySelector(this.payPalBtnSelector));

    if (buttonMessageStyle) {
        const updateAmount = () => {
            const pageType = Array.from(document.querySelectorAll('script[data-page-type]')).pop()
                .getAttribute('data-page-type');

            buttonMessageStyle.amount = helper.getPageAmount(pageType);

            btnInitResult.updateProps({
                message: buttonMessageStyle
            });
        };

        $('body')
            .on('cart:update', updateAmount)
            .on('count:update', updateAmount);
    }
};

module.exports = PayPalExpressModel;
